import { Component, type ErrorInfo, type ReactNode } from "react";
import { captureException } from "@/lib/sentry";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", error, info.componentStack);
    captureException(error, {
      extra: { componentStack: info.componentStack },
    });
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-canvas px-4 text-center text-ink">
          <h1 className="text-2xl font-bold text-block">系統發生錯誤</h1>
          <p className="max-w-md text-sm text-ink-muted">
            {this.state.error?.message || "未知錯誤"}
          </p>
          <button
            onClick={this.handleReload}
            className="rounded bg-action px-4 py-2 text-sm text-white hover:bg-action-hover"
          >
            重新載入
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
